import { toDate } from "@flaminem/utils";

import { AdminStatusFragment } from "src/graphql/anti-fraud/__generated__/graphql";
import { mapToUser } from "src/mappers/user.mappers";
import { AdminStatus } from "src/types/adminStatus";

export const mapToAdminStatus = (adminStatus: AdminStatusFragment): AdminStatus => ({
  author: mapToUser(adminStatus.author),
  creation: toDate(adminStatus.creation),
  lastModification: toDate(adminStatus.lastModification),
  lastModifier: mapToUser(adminStatus.lastModifier),
});
